import Dictionary from './dictionary/RU_ru';
import has from 'lodash/has';
import get from 'lodash/get';

class MagicDictionary {
	constructor(dictionaries = null) {
		this.messages = Dictionary;
		dictionaries && this.addDictionary(dictionaries);
		return new Proxy(this, this);
	}

	addDictionary(id, dictionary = null) {
		if (typeof id === 'string') {
			if (typeof dictionary === 'object')
				this.messages[id] = dictionary;
			else console.warn('dictionary type error');
		} else console.warn('dictionary id must be string');
	}

	trans(messageId = null, name = null) {
		typeof name == 'string' && messageId.search(/:.+$/) === -1 && (messageId = messageId.replace('~', name + ':'));
		return get(this.messages, messageId.replace(':', '.'), '⚠ ' + messageId);
	}
}

export default class MessagesPlugin {
	static install(Vue, options) {
		Vue.translator = Vue.prototype.$translator = new MagicDictionary(has(options, 'dictionaries') ? options['dictionaries'] : null);
		Vue.mixin({
			created() {
				if (this.$options.dictionary) {
					typeof this.$options.dictionary === 'function'
                    && this.$translator.addDictionary(this.$options.name || this.$options._componentTag, this.$options.dictionary());
					typeof this.$options.dictionary === 'object'
                    && this.$translator.addDictionary(this.$options.name || this.$options._componentTag, this.$options.dictionary);
				}
			},
			methods: {
				trans(id, name = null) {
					return this.$translator.trans(id, name || this.$options.name || this.$options._componentTag);
				}
			}
		});
	}
}